export default "__VITE_ASSET__BJu23PZy__"